import * as React from "react";

const Infographic = (props: { src: string }) => {
  return <img src={props.src} />;
};

export default Infographic;
